import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import compose from 'ramda/es/compose';
import { Footer } from './footer.component';
import {
  selectFooterData,
  selectFooterContentType,
  selectFooterEntryId,
} from '../../reducers/footer/footer.selectors';

const mapStateToProps = createStructuredSelector({
  footer: selectFooterData,
  contentType: selectFooterContentType,
  entryId: selectFooterEntryId,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(Footer);

